// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__55vKd","content":"Footer_content__QK5Po"};